<template>
  <div>
    <div class='container'>
      <div class='content-section'>
        <h3>
          海芯科技
          <div>三维创新设计及其编程教育引领者</div>
        </h3>
        <div class='slide'>
          <!-- <p><b>北京清软海芯科技有限公司</b>是一家专注于构建极致 3D 打印体验与闭环生态的国家级高新技术企业，其旗下商用 3D 打印高端品牌“优琢” （Neobox）面向教育、医疗和其他企业级应用提供一体化的软硬件平台系统，其包括具有自主知识产权的企业级 3D 打印设备、体验式与专业造型软件、云打印服务平台、全球最大的 3D 打印模型库与完备的课程服务体系。 </p>
          <p>公司由十余名清华大学校友联合创建，其核心技术团队来自中国、法国的学界与工业界，大多成员多年从事计算机图形学、计算机辅助设计与制造、工业控制技术和工业设计，经徐小平（真格基金）、余龙文、俞敏洪（泰有基金）等明星投资机构领投，现已发展为具有完备的设计、生产与服务能力的业界新秀。公司正通过其科研团队的自主研发和与清华大学等单位的广泛合作，以构建中国商用 3D 打印第一品牌为目标不懈努力。</p> -->
          <p>&nbsp;&nbsp;&nbsp;&nbsp; 北京清软海芯科技有限公司是一家专注于构建极致三维创新设计及其编程教育与3D打印体验产业生态的国家级高新技术企业。公司由十余名清华大学校友联合创建，核心技术团队大多数成员在计算机图形学、计算机辅助设计与制造、工业控制技术和工业设计领域具有多年的丰富实践经验。经泰有基金（余龙文、俞敏洪等）、真格基金（徐小平）、黑洞投资等明星投资机构投资，公司现已发展为设计、生产与服务能力体系完备的业界新秀。以三维创新设计及其编程教育引领者的目标不懈努力！</p>
        </div>
        <div>
          <img src='/static/developers.jpg' style='border-radius: 16px;width:100%'/>
        </div>
        <!--<h4>合伙人与团队</h4>-->
      </div>
      <div class='content-section' style='margin-top: 2'>&nbsp;<br />&nbsp;<br /></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'about',
  data() {
    return { };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .slide {
    background: #f0f0f0;
    padding: 2em 3em;
    margin-top: 2em;
    margin-bottom: 2em;
    line-height: 32px;
    border: solid 1px #ddd;
    border-radius: 16px;
    font-size: 18px;
    font-weight: 100;
  }
  .slide b {
    color: #0078d7;
  }
  .content-section {
  }
  .content-section .text {
    margin-left: 40px;
    color: #666;
    font-weight: 100;
    line-height: 1.7em;
  }
  .content-section ol {
    list-style: disc;
  }
  .content-section h3 {
    font-weight: 100;
    font-size: 48px;
    padding-left: 16px;
    border-left: solid 10px #b2d9e1;
  }
  .content-section h3 div {
    font-size: 36px;
    color: #666;
  }
  .code-rect {
    border-radius: 16px;
    border: solid 1px #ccc;
  }
  .code {
    font-family: Courier;
    font-weight: bold;
  }
  .code .k {
    font-weight: bold;
    color: #00f;
  }
  .code .n {
    color: #c00;
  }
  .formula {
    vertical-align: middle;
    text-align: center;
  }
  .formula .item {
    display: inline-block;
    border-radius: 8px;
    border: solid 1px #ccc;
    padding: 0.8em;
    text-align: center;
    vertical-align: middle;
    background-color: #f84;
    color: white;
  }
  .formula .symbol {
    display: inline-block;
    vertical-align: middle;
    font-size: 36px;
    font-weight: 400;
  }
  .formula span {
    font-size: 14px;
  }
  table th {
    padding: 0.8em 1em;
    border-bottom: solid 1px #ccc;
    color: #f84;
    font-size: 18px;
    text-align: left;
  }
  table td {
    padding: 0.5em 1em;
    text-align: left;
    font-size: 14px;
  }
  h4 {
    font-size: 38px;
    color: #a19063;
    font-weight:100;
  }
</style>



// WEBPACK FOOTER //
// src/components/about.vue